/*
  This is a flexable Card, works with all kind of cards on the website
  <Card
    game                  // Boolean, if is a game card, will reduce the width
    to                    // Card URL
    state                 // Top left corner badge, eg: "live", "available"
    thumbnailImg          // Thumbnail Image URL
    timeStatus            // Time Status, eg: 14:02
    title                 // Card Title
    userURL               // Avatar URL
    avatarImg             // Avatar Image URL
    verified              // Boolean, if the user is verified
    username              // Username or channel
    tournamentKind        // Tournament kind, eg: "Single Elimination"
    viewsCount            // viewers Counter, eg: 36.7k
    timePassed            // Moment Ago, how long the Article is published
    tags                  // Array of tags ["tag1", "tag2"]
    horizontal            // Horizontal Card
  />
*/
import React, { useState } from "react";
import axios from "axios";
import Moment from "moment";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Tag from "./Tag";
import { SmallAvatar } from "./Avatar";
import Button from "./Button";
import { handleBigNumbers } from "../utils";
import Dropdown from "./Dropdown";
import ReportModal from "./modals/Report";
import Modal from "./Modal";
// Import Icons
import { ReactComponent as MoreIcon } from "../img/icons/more.svg";
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";
import PlayIcon from "../img/icons/play-arrow.svg";
import { toast } from "react-toastify";
// Main component
const Card = (props) => {
  const [drop, setdrop] = useState(false);
  const [reportModal, setReportModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(process.env.REACT_APP_TOURNAMENT_DELETE_ENDPOINT + props.username, {
        withCredentials: true,
      })
      .then((res) => {
        toast.error("Tournament deleted succefuly");
        window.location.reload()
      })
      .catch((err) => {
        console.log(props.username);
        console.log(err);
      });
  };
  const cardop = [
    {
      type: 2,
      title: "Report",
      icon: null,
      func: () => setReportModal(true),
    },
    {
      type: 2,
      title: "Delete",
      icon: null,
      func: handleDelete,
    },
  ];

  const handleMore = () => {
    setdrop(!drop);
  };

  return (
    <>
      <CardContainer
        tournament={props?.tournament || []}
        game={props.game}
        horizontal={props.horizontal}
      >
        <Link to={props.to || ""}>
          <Thumbnail
            state={props.state}
            thumbnailImg={props.thumbnailImg}
            timeStatus={props.timeStatus}
            title={props.title}
            game={props.game}
            gif={props.gif}
          />
        </Link>
        <Body horizontal={props.horizontal}>
          {!props.game && props.avatar && !props.horizontal && (
            <SmallAvatar
              style={{ marginRight: "5px" }}
              to={props.userURL}
              src={props.avatarImg}
              alt={props.title}
            />
          )}
          <div style={{ flex: "1" }}>
            {props.title && (
              <Link to={props.to}>
                <Title>{props.title}</Title>
              </Link>
            )}
            {props.username && (
              <Link to={props.to}>
                {props.horizontal && (
                  <SmallAvatar
                    style={{ marginRight: "5px" }}
                    src={props.avatarImg}
                    alt={props.title}
                  />
                )}
                <Username>
                  {props.username}
                  {props.verified && <VerifiedIcon />}
                </Username>
              </Link>
            )}
            {props.tournamentKind && <TournamentKind>{props.tournamentKind}</TournamentKind>}
            {props.viewsCount && (
              <Footer
                viewsCount={handleBigNumbers(props.viewsCount)}
                timePassed={props.timePassed}
              />
            )}
            {props.tags && (
              <TagContainer game={props.game} horizontal={props.horizontal}>
                {props.tags.map((tag, index) => {
                  return <Tag key={index}>{tag}</Tag>;
                })}
              </TagContainer>
            )}
          </div>
          {!props.game && (
            <div style={{ position: "relative" }} onClick={handleMore}>
              <More icon className="more">
                <MoreIcon />
              </More>
              {drop && (
                <Dropdown
                  show={drop}
                  setShow={() => {
                    setdrop(!drop);
                  }}
                  style={{ top: "100%" }}
                  options={cardop}
                  margin="10px"
                />
              )}
            </div>
          )}
        </Body>
      </CardContainer>
      <Modal
        isOpen={reportModal}
        onRequestClose={() => setReportModal(false)}
        hideModal={() => setReportModal(false)}
      >
        <ReportModal id={props.postId} username={props.username} hideModal={setReportModal} />
      </Modal>
    </>
  );
};
export default Card;

// SubComponents
const Badge = ({ state, children }) => {
  return <BadgeStyle state={state}>{children}</BadgeStyle>;
};

export const Thumbnail = ({ state, thumbnailImg, timeStatus, title, game, gif }) => {
  return (
    <ThumbnailStyle game={game} video={timeStatus}>
      {state && <Badge state={state}>{state === "live" ? "Live" : "Available"}</Badge>}
      {gif && <img className="gif" src={gif} alt={title} />}
      {thumbnailImg && <img src={thumbnailImg} alt={title} />}
      {timeStatus && <TimeStatus>{timeStatus}</TimeStatus>}
    </ThumbnailStyle>
  );
};
const Footer = ({ viewsCount, timePassed }) => {
  return (
    <FooterStyle>
      <span>{viewsCount}</span>
      {timePassed && <span>{Moment(timePassed).fromNow()}</span>}
    </FooterStyle>
  );
};

// Styling
const CardContainer = styled.article`
  width: ${({ game }) => (game ? "140px" : "275px")};
  min-width: ${({ game }) => (game ? "140px" : "275px")};
  max-width: ${({ game }) => (game ? 140 : 400)}px;
  flex: 1;
  position: relative;
  /* > * {
    > * {
      border: 1px solid red;
      > * {
      }
    }
  } */
  & > a {
    display: inline-block;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 10px;
    ::before {
      content: "";
      border-radius: 4px;
      overflow: hidden;
      width: calc(100% + 10px);
      height: calc(100% + 10px);
      background-color: ${({ theme }) => theme.color.secondaryBg};
      position: absolute;
      inset: -5px;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
    }
    &:focus {
      ::before {
        opacity: 1;
        visibility: visible;
        transition: background-color 200ms ease;
      }
    }
  }
  &:hover {
    .more {
      opacity: 1;
      visibility: visible;
    }
  }
  ${({ horizontal }) =>
    horizontal &&
    `
      display: flex;
      max-width: 100%;
      width: 100%;
      & > a {
        max-width: 300px;
        margin-right: 20px;
        margin-bottom: 0;
      }
    `}
  @media (max-width: 768px) {
    width: 210px;
  }
  margin-bottom: ${({ tournament }) => (tournament ? 20 : 0)}px;
`;
const Body = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  a {
    display: inline-block;
    :focus {
      h6,
      span {
        color: ${({ theme }) => theme.color.primary} !important;
      }
    }
  }
  > div:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    > a:nth-of-type(2) {
      margin-top: 5px;
      display: flex;
      align-items: center;
      span {
        margin-top: 0;
      }
    }
  }
`;
const Username = styled.span`
  font-size: 12px;
  font-family: "Poppins Regular";
  margin-top: 2px;
  color: ${({ theme }) => theme.color.lighterText};
  ${({ theme }) => theme.linesLimits(1, 1.3)}
  svg {
    position: relative;
    top: 1px;
    width: 20px;
  }
`;
const TagContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  max-width: 232px;
  margin-bottom: 3px;
  overflow: hidden;
  display: flex;
  align-items: center;
  span {
    :focus,
    :active {
      box-shadow: none;
    }
    ${(props) =>
      !props.game &&
      `
        :first-child {
          background-color: ${props.theme.color.linkText};
          color: ${props.theme.color.white};
        }
      `}
  }
  ${({ horizontal }) =>
    horizontal &&
    `
      max-width: 100%;
    `}
`;
const TournamentKind = styled.span`
  color: ${({ theme }) => theme.color.danger};
  font-size: 10px;
`;
export const More = styled(Button)`
  position: relative;
  left: 5px;
  opacity: 0;
  visibility: hidden;

  svg circle {
    fill: ${({ theme }) => theme.color.darkerText};
  }
`;
const BadgeStyle = styled.div`
  user-select: none;
  pointer-events: none;
  background-color: ${({ theme, state }) =>
    state === "live" ? theme.color.danger : theme.color.primary};
  position: absolute;
  font-family: "Poppins Semibold";
  padding: 4px;
  left: 10px;
  top: 10px;
  border-radius: 4px;
  letter-spacing: 0.16em;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  color: white;
  font-size: 12px;
  z-index: 1;
`;
const TimeStatus = styled.div`
  padding: 5px;
  font-size: 10px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 5px;
  bottom: 5px;
  border-radius: 3px;
  letter-spacing: 0.7px;
`;
const Title = styled.h6`
  color: ${({ theme }) => theme.color.darkerText};
  ${({ theme }) => theme.linesLimits(1, 1.4)};
  transition: color 100ms;
  :hover {
    transition: color 200ms;
    color: ${({ theme }) => theme.color.primary};
  }
`;
const FooterStyle = styled.div`
  color: ${({ theme }) => theme.color.lighterText};
  font-size: 12px;
  display: flex;
  align-content: center;

  & > span:nth-child(2) {
    &::before {
      content: "•";
      margin: 0 4px;
    }
  }
`;

const ThumbnailStyle = styled.div`
  height: ${({ game }) => (game ? 200 : 200)}px;
  min-height: ${({ game }) => (game ? 200 : 120)}px;
  max-height: 170px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.color.secondaryBg};
  user-select: none;
  img:nth-of-type(2) {
    border-radius: 4px;
    height: 100%;
    width: 100%;
    transition: transform 100ms;
    object-fit: cover;
  }
  img.gif {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 100ms;
    :hover {
      opacity: 1;
      transition: opacity 200ms;
    }
  }
  ${({ video }) =>
    video &&
    `
      ::after {
        content: url(${PlayIcon});
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 50px;
        width: 50px;
        border-radius: 50px;
        background-color: #0000009a;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 100ms;
      }
      :hover{
        ::after{
          opacity: 1;
          transition: opacity 100ms;
        }
        img {
          transition: transform 200ms;
          transform: scale(1.1);
        }
      }
    `}
  @media (max-width: 768px) {
    height: 160px;
  }
`;
